var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 800,
  height: 800,
  viewBox: "0 0 800 800"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_362",
  "data-name": "Ellipse 362",
  cx: 400,
  cy: 400,
  r: 400,
  fill: "rgba(0,0,0,0.06)"
})));
export default __webpack_public_path__ + "static/media/circleShadowSignup.1c0e502b.svg";
export { SvgComponent as ReactComponent };